import {
	TInviteMemberPayload,
	TMember,
	TMemberInvitation,
	TMemberScope,
} from "@/types";

import API from "./api";

/**
 * The three members lists, which share one shape: a workspace, a client
 * (its projects follow, present and future) or a single project.
 *
 * Inviting on a client or a project also lets the person into the
 * workspace, as NONE - the API does it in the same call, so the front
 * has one gesture to offer (docs/modele.md, phase 5).
 */
class MembersClass {
	list = (scope: TMemberScope, id: number): Promise<TMember[]> => {
		return API.get(`${scope}/${id}/members`).then((res) => res.data);
	};

	add = (
		scope: TMemberScope,
		id: number,
		payload: TInviteMemberPayload
	): Promise<TMember | TMemberInvitation> => {
		return API.post(`${scope}/${id}/members`, payload).then(
			(res) => res.data
		);
	};

	/** Partial: `rate: null` clears the override, an omitted rate is left alone. */
	update = (
		scope: TMemberScope,
		id: number,
		userId: number,
		payload: Partial<Pick<TInviteMemberPayload, "role" | "rate">>
	): Promise<TMember> => {
		return API.patch(`${scope}/${id}/members/${userId}`, payload).then(
			(res) => res.data
		);
	};

	/** Removes someone, or leaves when `userId` is your own. */
	remove = (scope: TMemberScope, id: number, userId: number) => {
		return API.delete(`${scope}/${id}/members/${userId}`).then(
			(res) => res.data
		);
	};
}

const MembersService = new MembersClass();
export default MembersService;
